var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoDemographics(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 128,
    height: 129,
    viewBox: "0 0 128 129",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M-572-22H578v754H-572z"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    strokeWidth: 4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.11 72.347c3.746-2.629 6.288-7.739 6.288-13.612 0-8.56-6.997-11.411-12.059-11.411-5.062 0-12.059 2.852-12.059 11.411 0 5.873 2.542 10.983 6.29 13.612-7.648 2.468-14.81 9.42-14.81 17.611 0 10.256 10.29 11.328 20.58 11.328 10.289 0 20.578-1.072 20.578-11.328 0-8.19-7.161-15.143-14.809-17.611z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M49.618 57.002a19.662 19.662 0 0 0-4.07-1.86c3.122-2.191 5.24-6.45 5.24-11.344 0-7.132-5.83-9.51-10.05-9.51-4.218 0-10.048 2.378-10.048 9.51 0 4.894 2.118 9.153 5.24 11.343-6.372 2.057-12.34 7.85-12.34 14.676 0 8.547 8.574 9.44 17.149 9.44a73.1 73.1 0 0 0 4.297-.108M73.14 56.951a19.643 19.643 0 0 1 3.986-1.81c-3.122-2.19-5.24-6.449-5.24-11.343 0-7.132 5.83-9.51 10.048-9.51 4.219 0 10.05 2.378 10.05 9.51 0 4.894-2.119 9.153-5.241 11.343 6.373 2.057 12.34 7.85 12.34 14.676 0 8.547-8.574 9.44-17.149 9.44-1.468 0-2.936-.026-4.361-.112"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoDemographics);
export default __webpack_public_path__ + "static/media/ico-demographics.ff81627806025a0210f75b3b48010b07.svg";
export { ForwardRef as ReactComponent };